import React, { useState, useEffect, useRef } from "react";
import JobOpening from "../CurrentJobOpening/Component/JobOpeningComponent";
import { useLocation, useNavigate } from "react-router-dom";
import { API_URL } from "../../../constants/index";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import { GetServiceCaller } from "../../../services/serviceCaller";
import moment from "moment";
import { Link, useParams } from "react-router-dom";

function CurrentJobOpening() {
  const { profileID } = useParams();
  const [postJob, setPostJob] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [clickedId, setClickedId] = useState("");
  const [modalData, setModalData] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [typeOptions, setTypeOptions] = useState([]);
  const [technologyOptions, setTechnologyOptions] = useState([]);
  const [LocationOptions, setLocationOptions] = useState([]);
  const [jobTitleOptions, setjobTitleOptions] = useState([]);
  const [formData, setFormData] = useState({
    Title: [],
    Description: "",
    NoOfPosition: 1,
    JobType: "",
    Technology: [],
    Qualification: "",
    MinExperience: "",
    MaxExperience: "",
    budget_min_scale: "",
    budget_max_scale: "",
    Location: [],
    ActiveDate: moment().format("DD-MMM-YYYY"),
    TargetDate: moment().format("DD-MMM-YYYY"),
    IsInActive: 0,
  });

  function convertHtmlToPlainText(str) {
    return str
      .replace(/<ul>/gi, "") // remove <ul>
      .replace(/<\/ul>/gi, "") // remove </ul>
      .replace(/<li>/gi, "- ") // bullet list
      .replace(/<\/li>/gi, "\n") // newline after each item
      .replace(/<br\s*\/?>/gi, "\n") // <br> as newline
      .replace(/<\/p>/gi, "\n") // end of paragraph
      .replace(/<p[^>]*>/gi, "") // remove opening <p>
      .replace(/&nbsp;/gi, " ") // convert to space (not newline)
      .replace(/<\/?[^>]+(>|$)/g, "") // strip remaining tags
      .replace(/\n{2,}/g, "\n") // collapse multiple \n to one
      .trim();
  }

  const modalRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setShowModal(false);
      }
    };

    if (showModal) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showModal]);

  const location = useLocation();

  const [originalData, setOriginalData] = useState([]);

  useEffect(() => {
    if (originalData.length === 0) return;
    const queryParams = new URLSearchParams(location.search);
    const fromDate = queryParams.get("FromDate");
    const filteredData = originalData.filter((item) => {
      const TarDate = moment(item.TargetDate);
      const fromCondition = fromDate
        ? TarDate.isSameOrAfter(moment(fromDate), "day")
        : true;

      return fromCondition;
    });
    setPostJob(filteredData);
  }, [location.search, originalData]);

  const [apiStatus, setApiStatus] = useState(undefined);
  const fetchSkills = async (id) => {
    setApiStatus(undefined);
    try {
      const response = await GetServiceCaller(
        `${API_URL}JobDescriptions?jobDescriptionid=${id}`
      );
      setApiStatus(response.status);

      if (response.status === 200) {
        const cleanedData = response?.data?.data?.data;
        setPostJob(cleanedData);
        setOriginalData(cleanedData);
        const modalData = response?.data?.data?.jobdescriptionlist;
        setModalData(modalData);
      } else {
        console.error(
          "Failed to fetch skills. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching skills:", error);
    }
  };

  useEffect(() => {
    fetchSkills("");
  }, []);

  useEffect(() => {
    if (clickedId) {
      fetchSkills(clickedId);
    }
  }, [clickedId]);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Job Openings"));
  }, []);

  const columns = {
    Title: { text: "Title" },
    NoOfPosition: { text: "# Pos" },
    ActiveDate: { text: "Active Date" },
    TargetDate: { text: "Target Date" },
    ModifiedByName: { text: "HR" },
    // LeadCount: { text: "# Leads" },
    // IsInActive: { text: "Active" },
  };
  const defaultColumns = {
    Title: true,
    NoOfPosition: true,
    ActiveDate: true,
    TargetDate: true,
    ModifiedByName: true,
    // LeadCount: true,
    IsInActive: true,
  };

  const navigate = useNavigate();

  useEffect(() => {
    if (profileID) {
      fetchData(profileID);
      setShowModal(true);
    }
  }, [profileID]);
  const handleEdit = (id) => {
    fetchData(id.ID);
    setShowModal(true);
  };
  const fetchData = async (id) => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}JobDescriptions/create`
      );
      const technologyData = response?.data?.data?.technology;
      const locationoption = response?.data?.data?.projectlocation;
      const titleoption = response?.data?.data?.job_titles;

      const options = technologyData?.map((tech) => ({
        value: tech.ID,
        label: tech.Name,
      }));
      const LocationOption = locationoption?.map((tech) => ({
        value: tech.ID,
        label: tech.Name,
      }));
      const TitleOption = titleoption?.map((tech) => ({
        value: tech.ID,
        label: tech.Name,
      }));
      TitleOption.unshift({ value: null, label: "Select.." });
      LocationOption.unshift({ value: null, label: "Select.." });

      setTechnologyOptions(options);
      setLocationOptions(LocationOption);
      setjobTitleOptions(TitleOption);

      const jobType = response?.data?.data?.jobType;
      const jobTypeOptions = jobType?.map((master) => ({
        value: master.value,
        label: master.Description,
      }));
      setTypeOptions(jobTypeOptions);
      if (id) {
        try {
          const response = await GetServiceCaller(
            `${API_URL}JobDescriptions/${id}`
          );
          if (response.status === 200) {
            const job = response?.data?.data;
            if (job) {
              const {
                Title,
                JobMasterID,
                Description,
                NoOfPosition,
                JobType,
                Technology,
                MinExperience,
                MaxExperience,
                budget_min_scale,
                budget_max_scale,
                Qualification,
                Location,
                ActiveDate,
                TargetDate,
                IsInActive,
              } = job;

              // Job display in select form string to array
              let job_selected = { value: JobMasterID, label: Title };

              // Techology is selected from a ids string to array
              let technology_selected = [];
              Technology?.split(",").forEach((element) => {
                technology_selected.push(
                  options.find((o) => o.value == element)
                );
              });

              //Location to be shown in select from string to array
              let location_selected = [];
              Location?.split(",")
                .map((item) => item.trim())
                .forEach((element) => {
                  location_selected.push(
                    LocationOption.find((L) => L.label === element)
                  );
                });
              // Update form data with fetched values
              let job_type_selected = {};
              for (let type of jobTypeOptions) {
                if (type.value == JobType) {
                  job_type_selected = type;
                }
              }
              setFormData({
                Title: job_selected || "",
                Description: Description || "",
                NoOfPosition: NoOfPosition || "",
                JobType: job_type_selected || "",
                Technology: technology_selected || "",
                Qualification: Qualification || "",
                MinExperience: MinExperience || "",
                MaxExperience: MaxExperience || "",
                budget_min_scale: budget_min_scale || "",
                budget_max_scale: budget_max_scale || "",
                Location: location_selected || "",
                ActiveDate: moment(ActiveDate).format("DD-MMM-YYYY") || "",
                TargetDate: moment(TargetDate).format("DD-MMM-YYYY") || "",
                IsInActive: IsInActive ? 1 : 0,
              });
            } else {
              console.error("Job not found with ID:", id);
            }
          } else {
            console.error(
              "Failed to fetch job details. Server responded with status:",
              response.status
            );
          }
          // setPageLoading(false);
        } catch (error) {
          console.error("Error fetching job details:", error);
        }
      }
    } catch (error) {
      console.error("Error fetching technology options:", error);
    }
  };
  const handleEditModalClose = () => {
    setShowModal(false);
  };
  const handleShowModalInParent = (id) => {
    setClickedId(id);
  };
  const handleRefer = (id) => {
    navigate("/refer-candidate/add", { state: id });
  };
  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <JobOpening
              data={postJob}
              modalData={modalData}
              columns={columns}
              isApiStatus={apiStatus}
              defaultColumns={defaultColumns}
              itemsPerPage={8}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              showIcon1={true}
              showIcon2={true}
              handleIcon1={handleEdit}
              handleIcon2={handleRefer}
              icons={{
                Icon1: <i className="bi bi-eye-fill"></i>,
                Icon2: <i className="bi bi-plus-circle-dotted"></i>,
                Icon2Text: "Refer Candidate",
              }}
              handleShowModalInParent={handleShowModalInParent}
            />
          </div>
        </div>
        {showModal && (
          <div
            className="modal"
            tabIndex="-1"
            role="dialog"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 1050,
            }}
          >
            <div
              className="modal-dialog modal-lg"
              role="document"
              style={{
                width: "700px",
                margin: 0,
                maxHeight: "90vh",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                className="modal-content"
                ref={modalRef}
                style={{
                  maxHeight: "90vh",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {/* Fixed Header */}
                <div
                  className="modal-header"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderBottom: "1px solid #f0f0f0",
                    backgroundColor: "#f8f9fa",
                    borderRadius: "8px 8px 0 0",
                    padding: "1rem",
                    flexShrink: 0,
                  }}
                >
                  <p
                    style={{
                      fontSize: "16px",
                      fontWeight: "600",
                      color: "#27568B",
                      margin: "0",
                    }}
                  >
                    Job Description
                  </p>
                  <button
                    onClick={handleEditModalClose}
                    style={{
                      background: "none",
                      border: "none",
                      fontSize: "1.25rem",
                      cursor: "pointer",
                    }}
                  >
                    <i className="bi bi-x-lg"></i>
                  </button>
                </div>

                {/* Scrollable Body */}
                <div
                  className="modal-body"
                  style={{
                    overflowY: "auto",
                    flex: 1,
                    padding: "1rem",
                  }}
                >
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="row">
                          <div className="col-md-4">
                            <div className="job-detail-item">
                              <span className="detail-label">
                                <strong>Job Title</strong> :{" "}
                                {formData.Title?.label || "N/A"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="job-detail-item">
                              <span className="detail-label">
                                <strong>Type</strong> :{" "}
                                {formData.JobType?.label || "N/A"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="job-detail-item">
                              <span className="detail-label">
                                <strong>Active Date</strong> :{" "}
                                {formData.ActiveDate || "N/A"}
                              </span>
                            </div>
                          </div>
                        </div>

                        <div className="row mt-3">
                          <div className="col-md-4">
                            <div className="job-detail-item">
                              <span className="detail-label">
                                <strong>Experience</strong> :{" "}
                                <span className="detail-value">
                                  {formData.MinExperience || "0"} -{" "}
                                  {formData.MaxExperience || "0"} Years
                                </span>
                              </span>
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="job-detail-item">
                              <span className="detail-label">
                                <strong>#POS</strong> :{" "}
                                {formData.NoOfPosition || "0"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="job-detail-item">
                              <span className="detail-label">
                                <strong>Qualification</strong> :{" "}
                                {formData.Qualification || "N/A"}
                              </span>
                            </div>
                          </div>
                        </div>

                        <div className="row mt-3">
                          <div className="col-md-4">
                            <div className="job-detail-item">
                              <span className="detail-label">
                                <strong>Location</strong> :{" "}
                                <span className="detail-value">
                                  {Array.isArray(formData.Location) &&
                                  formData.Location.length > 0
                                    ? formData.Location.filter(
                                        (loc) => loc && loc.label
                                      )
                                        .map((loc) => loc.label)
                                        .join(", ")
                                    : "N/A"}
                                </span>
                              </span>
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="job-detail-item">
                              <span className="detail-label">
                                <strong>Technology</strong> :{" "}
                                <span className="detail-value">
                                  {Array.isArray(formData.Technology) &&
                                  formData.Technology.length > 0
                                    ? formData.Technology.filter(
                                        (tech) => tech && tech.label
                                      )
                                        .map((tech) => tech.label)
                                        .join(", ")
                                    : "N/A"}
                                </span>
                              </span>
                            </div>
                          </div>
                        </div>

                        <div className="row mt-3">
                          <div className="col-md-12">
                            <div className="form-group">
                              <label className="form-label">
                                <strong>Job Description</strong>
                              </label>
                              <div
                                className="job-description"
                                style={{
                                  whiteSpace: "pre-line",
                                  maxHeight: "300px",
                                  overflowY: "auto",
                                  padding: "0.75rem",
                                  border: "1px solid #dee2e6",
                                  borderRadius: "0.375rem",
                                  backgroundColor: "#f8f9fa",
                                }}
                              >
                                {convertHtmlToPlainText(
                                  formData.Description ||
                                    "No description provided"
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Fixed Footer */}
                <div
                  className="modal-footer"
                  style={{
                    borderTop: "1px solid #f0f0f0",
                    backgroundColor: "#f8f9fa",
                    borderRadius: "0 0 8px 8px",
                    padding: "0.5rem",
                    flexShrink: 0,
                  }}
                >
                  <div className="d-flex justify-content-end w-100">
                    {/* <div className="d-flex align-items-center">
                      <label
                        className="form-label me-2 mb-0"
                        style={{ marginTop: "-5px" }}
                      >
                        <strong>Active</strong>
                      </label>
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="isActive"
                          id="isActiveYes"
                          checked={formData.IsInActive == 1}
                          readOnly
                        />
                        <label
                          className="form-check-label"
                          htmlFor="isActiveYes"
                        >
                          Yes
                        </label>
                      </div>
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="isActive"
                          id="isActiveNo"
                          checked={formData.IsInActive == 0}
                          readOnly
                        />
                        <label
                          className="form-check-label"
                          htmlFor="isActiveNo"
                        >
                          No
                        </label>
                      </div>
                    </div> */}

                    <button
                      className="cancel-btn"
                      onClick={handleEditModalClose}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default CurrentJobOpening;
